export default __webpack_public_path__ + "static/media/image-trainingResults-2000x3000-png.b03482e0.png";